import { useWhatsAppContext } from '@providers/whatsApp/hooks';

export const useController = () => {
  const {
    isOpen,
    whatsAppNumber,
  } = useWhatsAppContext();

  return {
    isOpen,
    whatsAppNumber,
  };
};
